import { ContentfulPageSectionStyle } from '@typings/contentful-page-section-template'
import SectionTemplateDefault from '@ui/section-template-default'
import SectionTemplateFiligraneLeft from '@ui/section-template-filigrane-left'
import SectionTemplateFiligraneRight from '@ui/section-template-filigrane-right'
import React, { type FC, type PropsWithChildren } from 'react'

import SectionTemplateBackground from './section-template-background'

const templateMapping: Record<ContentfulPageSectionStyle | string, any> = {
  [ContentfulPageSectionStyle.FILIGRANE_LEFT]: SectionTemplateFiligraneLeft,
  [ContentfulPageSectionStyle.FILIGRANE_RIGHT]: SectionTemplateFiligraneRight,
  [ContentfulPageSectionStyle.REFRESH_WHITE_BACKGROUND]:
    SectionTemplateBackground,
  [ContentfulPageSectionStyle.REFRESH_GREY_BACKGROUND]:
    SectionTemplateBackground,
  [ContentfulPageSectionStyle.REFRESH_BLUE_BACKGROUND]:
    SectionTemplateBackground,
  [ContentfulPageSectionStyle.REFRESH_GRADIENT_BACKGROUND]:
    SectionTemplateBackground,
  [ContentfulPageSectionStyle.PREMIUM_BLACK]: SectionTemplateBackground,
  [ContentfulPageSectionStyle.ICONIC_1]: SectionTemplateBackground,
  [ContentfulPageSectionStyle.ICONIC_2]: SectionTemplateBackground,
  [ContentfulPageSectionStyle.DEFAULT]: SectionTemplateDefault,
}

export type SectionProps = {
  isEmpty?: boolean
  style?: ContentfulPageSectionStyle | string
} & PropsWithChildren

export const SectionTemplate: FC<SectionProps> = ({
  isEmpty,
  style,
  children,
}) => {
  const Template =
    templateMapping[style] ||
    templateMapping[ContentfulPageSectionStyle.DEFAULT]

  return (
    <Template isEmpty={isEmpty} style={style}>
      {children}
    </Template>
  )
}
